import React, { Fragment, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Table from './Table'
import CreatePopup from './CreatePopup'
import UpdatePopup from './UpdatePopup'

import {
  getCompanyIskurInfoList,
  toggleCreatePopup,
  setSearchTerm,
  setCurrentCompanyGroupId
} from './store'

const CompanyIskurInfoPage = () => {
  const dispatch = useDispatch()
  const {
    data,
    loading,
    searchTerm
  } = useSelector(s => s.companyIskurInfo)
  
  const authStore = useSelector(state => state.auth)

  // ** States
  const [filteredData, setFilteredData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  useEffect(() => {
    if (authStore.selectedCompanyGroup && authStore.selectedCompanyGroup !== 0) {
      dispatch(getCompanyIskurInfoList(authStore.selectedCompanyGroup))
      dispatch(setCurrentCompanyGroupId(authStore.selectedCompanyGroup))
    }
  }, [dispatch, authStore.selectedCompanyGroup])

  useEffect(() => {
    let filtered = data

    if (searchTerm) {
      filtered = data.filter(item => item.iskurCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.companyNames.some(name => name.toLowerCase().includes(searchTerm.toLowerCase()))
      )
    }

    setFilteredData(filtered)
    setCurrentPage(1) 
  }, [data, searchTerm])

  const startIndex = (currentPage - 1) * rowsPerPage
  const endIndex = startIndex + rowsPerPage
  const paginatedData = filteredData.slice(startIndex, endIndex)

  const handlePagination = page => {
    setCurrentPage(page.selected + 1)
  }

  const handlePerPage = e => {
    const value = parseInt(e.currentTarget.value)
    setRowsPerPage(value)
    setCurrentPage(1)
  }

  const handleFilter = val => {
    dispatch(setSearchTerm(val))
  }

  return (
    <Fragment>
      <Table
        data={paginatedData}
        total={filteredData.length}
        loading={loading}
        searchTerm={searchTerm}
        rowsPerPage={rowsPerPage}
        currentPage={currentPage}
        handleFilter={handleFilter}
        handlePerPage={handlePerPage}
        handlePagination={handlePagination}
        toggleSidebar={() => dispatch(toggleCreatePopup(true))}
      />
      
      <CreatePopup />
      <UpdatePopup />
    </Fragment>
  )
}

export default CompanyIskurInfoPage